import { useEffect } from 'react';
import {
    FileText, ShieldCheck, Zap, TrendingUp, ChevronRight,
    Layers, BarChart3, Target, Lock, CheckCircle2, ArrowRight,
    QrCode, Users, ShoppingCart, Brain, Wallet, Server
} from 'lucide-react';
import { Link } from 'react-router-dom';

const DocsWhitepaper = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const problems = [
        {
            title: 'Uygulama Yorgunluğu',
            desc: 'Kimse bir kahve sadakati icin 100 MB uygulama indirmek istemiyor. Arastirmalar, isletme basina ayri uygulama indirme taleplerinin musterilerin %70\'ini kaybettigini gosteriyor.',
            icon: Zap,
            color: '#f59e0b'
        },
        {
            title: 'Veri Korlugu',
            desc: 'Kasadan para cikiyor ama karlilik nerede? Musteri aliskanliklari, stok maliyetleri ve kampanya etkisi arasindaki bag kopuk oldugunda isletme kor noktalarda kaliyor.',
            icon: Target,
            color: '#8b5cf6'
        },
        {
            title: 'Enflasyonist Baski',
            desc: 'Degisen maliyetleri anlik olarak menuye ve stok yonetimine yansitamamak isletmeleri zarara ugratiyor. Kagit menu basim maliyetleri de cabasi.',
            icon: TrendingUp,
            color: '#ef4444'
        }
    ];

    const techSpecs = [
        { component: 'Onyuz (Frontend)', tech: 'React 19 + Vite', benefit: 'Milisaniyelik render, SPA deneyimi, sifir kurulum.' },
        { component: 'Backend & Veritabani', tech: 'Supabase (PostgreSQL)', benefit: 'Real-time sync, Row Level Security, multi-tenant izolasyon.' },
        { component: 'Deployment', tech: 'Vercel Serverless', benefit: 'Edge dagitim, otomatik olceklendirme, %99.9 uptime.' },
        { component: 'Cache & Rate Limit', tech: 'Upstash Redis', benefit: 'Sunucusuz Redis, <1ms latency, rate limiting & session yonetimi.' },
        { component: 'AI Motoru', tech: 'Gemini 2.5 Flash', benefit: 'Menu muhendisligi, kampanya onerisi, stok analizi.' },
        { component: 'Odeme', tech: 'iyzico Checkout', benefit: 'Guvenli odeme, taksit destegi, PCI DSS uyumlu.' },
    ];

    const platformModules = [
        { icon: QrCode, title: 'QR Menu Yonetimi', desc: 'Kategoriler, urunler, gorseller. Anlik guncelleme, kagit menu maliyeti sifir.', color: '#10b981' },
        { icon: Users, title: 'Musteri CRM', desc: 'Sinir-siz musteri kaydi, sadakat seviyeleri, ziyaret frekansi analizi, segmentasyon.', color: '#0ea5e9' },
        { icon: ShoppingCart, title: 'Siparis Yonetimi', desc: 'Portaldan gelen siparisleri gercek zamanli takip, durum guncelleme, gecmis kayitlari.', color: '#f59e0b' },
        { icon: BarChart3, title: 'Analitik & Raporlar', desc: 'Gelir analizi, musteri dagilimi, kampanya performansi, trend grafikleri.', color: '#8b5cf6' },
        { icon: Layers, title: 'Stok & Muhasebe', desc: 'Urun bazli maliyet takibi, tedarikci yonetimi, gelir-gider raporlari.', color: '#ec4899' },
        { icon: Brain, title: 'AI Danisman', desc: 'Gemini ile menu optimizasyonu, kampanya fikirleri, stok analizi onerisi.', color: '#6366f1' },
    ];

    return (
        <div style={{ animation: 'fadeIn 0.3s ease-out' }}>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 900, marginBottom: '1rem', letterSpacing: '-0.02em', borderBottom: '1px solid var(--border)', paddingBottom: '1.5rem', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <FileText style={{ color: 'var(--primary)' }} size={32} /> Whitepaper v2.0
            </h1>
            <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem', marginBottom: '3rem', lineHeight: 1.6 }}>
                ugra, kafe ve restoranlarin dijital donusumunu QR menu, musteri sadakati, siparis yonetimi ve yapay zeka ile tek platformda birlestiren bir SaaS cozumudur. Bu dokümanda pazar analizi, çözüm yaklaşımımız ve teknik mimari detayları yer almaktadır.
            </p>

            <style>{`
                .wp-section { margin-bottom: 4rem; }
                .wp-card { background: var(--bg-card); border: 1px solid var(--border); border-radius: 16px; padding: 1.5rem; transition: all 0.3s; }
                .wp-card:hover { border-color: var(--primary); box-shadow: 0 4px 20px rgba(0,0,0,0.05); }
                .wp-grid-3 { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1.25rem; }
                .wp-table { width: 100%; border-collapse: separate; border-spacing: 0; }
                .wp-table th, .wp-table td { padding: 1rem 1.25rem; text-align: left; border-bottom: 1px solid var(--border); font-size: 0.9rem; }
                .wp-table th { font-size: 0.8rem; font-weight: 800; text-transform: uppercase; color: var(--text-muted); letter-spacing: 0.05em; background: rgba(0,0,0,0.02); }
                .wp-table tr:last-child td { border-bottom: none; }
                .dark .wp-table th { background: rgba(255,255,255,0.02); }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
            `}</style>


            <div className="wp-section">
                <h2 style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ color: 'var(--primary)' }}>1.</span> Problem ve Vizyon
                </h2>
                <div style={{ background: 'var(--bg-card)', padding: '1.5rem', borderRadius: '16px', border: '1px solid var(--border)' }}>
                    <p style={{ color: 'var(--text-muted)', lineHeight: 1.7, fontSize: '0.95rem', marginBottom: '1rem' }}>
                        Turkiye'de 500.000'den fazla kafe ve restoran bulunmaktadir. Bu isletmelerin buyuk cogunlugu dijital donusum araclarindan yoksundur: kagit menuler, fiziksel sadakat kartlari, Excel tabanlari muhasebe ve sezgisel kampanya kararlari ile calismayi surdurmektedir.
                    </p>
                    <p style={{ color: 'var(--text-muted)', lineHeight: 1.7, fontSize: '0.95rem' }}>
                        ugra, bu sorunu uctan uca cozen bir isletme yonetim platformudur. Musteriler uygulama indirmeden QR kod ile check-in yapar, dijital menuyu gorur, siparis verir ve sadakat puani kazanir. Isletmeler ise tek panelden menu, musteri, siparis, stok, muhasebe ve kampanyalarini yonetir.
                    </p>
                </div>
            </div>

            <div className="wp-section">
                <h2 style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ color: 'var(--primary)' }}>2.</span> Pazar Problemleri
                </h2>
                <div className="wp-grid-3">
                    {problems.map((p, i) => (
                        <div key={i} className="wp-card">
                            <div style={{ width: 42, height: 42, borderRadius: 12, background: `${p.color}15`, color: p.color, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem' }}>
                                <p.icon size={20} />
                            </div>
                            <h3 style={{ fontWeight: 800, fontSize: '1.1rem', marginBottom: '0.5rem' }}>{p.title}</h3>
                            <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', lineHeight: 1.6 }}>{p.desc}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="wp-section">
                <h2 style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ color: 'var(--primary)' }}>3.</span> Çözüm Modülleri
                </h2>
                <div className="wp-grid-3">
                    {platformModules.map((m, i) => (
                        <div key={i} className="wp-card" style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                            <div style={{ width: 36, height: 36, borderRadius: '10px', background: `${m.color}15`, color: m.color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <m.icon size={18} />
                            </div>
                            <div>
                                <h3 style={{ fontWeight: 700, fontSize: '0.95rem', marginBottom: '0.25rem' }}>{m.title}</h3>
                                <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', lineHeight: 1.5 }}>{m.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="wp-section">
                <h2 style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ color: 'var(--primary)' }}>4.</span> Teknik Spesifikasyonlar
                </h2>
                <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 16, overflow: 'hidden' }}>
                    <div style={{ overflowX: 'auto' }}>
                        <table className="wp-table">
                            <thead>
                                <tr>
                                    <th>Katman / Bileşen</th>
                                    <th>Teknoloji</th>
                                    <th>Avantaj</th>
                                </tr>
                            </thead>
                            <tbody>
                                {techSpecs.map((s, i) => (
                                    <tr key={i}>
                                        <td style={{ fontWeight: 700, whiteSpace: 'nowrap' }}>{s.component}</td>
                                        <td style={{ color: 'var(--primary)', fontWeight: 600, whiteSpace: 'nowrap' }}>{s.tech}</td>
                                        <td style={{ color: 'var(--text-muted)' }}>{s.benefit}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div className="wp-section">
                <h2 style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ color: 'var(--primary)' }}>5.</span> Finansal Değer (ROI)
                </h2>
                <div className="wp-grid-3">
                    {[
                        { icon: TrendingUp, title: 'Operasyonel Tasarruf', desc: 'Kagit menu ve fiziksel kart maliyetlerinde yillik %25 azalma. Dijital menu anlik guncellenir.', color: '#10b981' },
                        { icon: BarChart3, title: 'Ciro Artisi', desc: 'Akilli kampanyalar ve sadakat sistemiyle musteri donus oraninda %30 artis hedefi.', color: '#8b5cf6' },
                        { icon: Wallet, title: 'Veri Degeri', desc: 'Sifir veri kaybi. Degerli musteri kontak bilgileri platform degisikliginde bile erisilebilir.', color: '#f59e0b' },
                    ].map((r, i) => (
                        <div key={i} className="wp-card" style={{ display: 'flex', gap: 12 }}>
                            <div style={{ width: 40, height: 40, borderRadius: 12, background: `${r.color}15`, color: r.color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <r.icon size={20} />
                            </div>
                            <div>
                                <h3 style={{ fontWeight: 700, fontSize: '0.95rem', marginBottom: '0.25rem' }}>{r.title}</h3>
                                <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', lineHeight: 1.5 }}>{r.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '4rem', paddingTop: '2rem', borderTop: '1px solid var(--border)' }}>
                <Link to="/getting-started" style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--text-muted)', textDecoration: 'none', fontWeight: 600 }}>
                    <ChevronRight size={18} style={{ transform: 'rotate(180deg)' }} /> Hızlı Başlangıç
                </Link>
                <Link to="/roadmap" style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--primary)', textDecoration: 'none', fontWeight: 600 }}>
                    Yol Haritası (Roadmap) <ChevronRight size={18} />
                </Link>
            </div>
        </div>
    );
};

export default DocsWhitepaper;
